import { actionTypes } from "../constants/actionTypes";
import CommonApis from "../../helper/common.api";
import AuthApis from "../../helper/auth.api";

// Action creator
const setUser = user => ({
  type: actionTypes.SET_USER,
  payload: user,
});

// Thunk action creator
export const fetchCurrentUser = () => {
  return async (dispatch, getState) => {
    try {
      const api = new CommonApis();
      const res = await api.getCurrentProfile();
      dispatch(setUser(res.data.result));
      return res.data.result;
    } catch (err) {
      console.error("Error fetching user:", err);
      throw err;
    }
  };
};

// Thunk to set is18AndAbove true in backend and Redux
export const updateUser = updateFields => {
  return async dispatch => {
    try {
      const api = new AuthApis();
      const res = await api.updateProfile(updateFields);
      dispatch(setUser(res.data.result));
      return res.data.result;
    } catch (err) {
      console.error("Error updating user profile:", err);
      throw err;
    }
  };
};

// Export all action creators
export const userActions = {
  setUser,
  fetchCurrentUser,
  updateUser,
};
